import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing, flags }: Theme) => createStyles({
  notificationsContainer: {
    borderTop: flags.boxStyle === 'stroke' ? `2px solid ${colors.pageElements.notificationCard.stroke}` : 'none',
  },
  pagination: {
    minHeight: 'auto',
    marginTop: spacing(6),
  },
});

export default styles;
